import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { H1 } from '../../../../atoms/Heading/Heading';
import { Text } from '../../../../atoms/Text/Text';
import { ProviderField } from '../../../../../models/provider';

export type TitleImageFieldsProps = {
  title?: ProviderField;
  image?: ProviderField;
};

export const TitleImageFields = ({
  title = undefined,
  image = undefined,
}: TitleImageFieldsProps) => {
  return (
    <>
      {title && (
        <>
          <H1 id="title">{title.value}</H1>
          <Text id="subtitle" color="secondary" mb="normal">
            {title.helpText}
          </Text>
        </>
      )}

      {image?.value && (
        <>
          <img src={image.value} alt={image?.description ?? ''} data-testid="question-image" />

          <Spacer size="small" />

          {image?.helpText && (
            <Text color="secondary" mb="small" id="image-helptext">
              {image.helpText}
            </Text>
          )}
        </>
      )}
    </>
  );
};
